<template>
    <div class="vimeo-iframe-wrapper">
		<iframe
            :src="videoSource"
            style="position:absolute;top:0;left:0;width:100%;height:100%;"
            frameborder="0"
            webkitallowfullscreen
            mozallowfullscreen
            allowfullscreen
        ></iframe>
	</div>
</template>

<script>
export default {
    props: {
        videoId: {
            required: true,
            type: Number,
        },
    },
    computed: {
        videoSource: function() {
            return `https://player.vimeo.com/video/${this.videoId}?color=ffffff&portrait=0`
        },
    },
}
</script>

<style scoped>
.vimeo-iframe-wrapper {
    padding: 56.25% 0 0 0;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/project/components/VimeoPlayer.vue